import { render } from "./Hero.vue?vue&type=template&id=42842272"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
script.render = render

export default script